import { render, staticRenderFns } from "./AssetReport.vue?vue&type=template&id=226e04b5&"
import script from "./AssetReport.vue?vue&type=script&lang=js&"
export * from "./AssetReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports